var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6875 3.75C1.6875 3.20299 1.9048 2.67839 2.29159 2.29159C2.67839 1.9048 3.20299 1.6875 3.75 1.6875H14.25C14.797 1.6875 15.3216 1.9048 15.7084 2.29159C16.0952 2.67839 16.3125 3.20299 16.3125 3.75V11.25C16.3125 11.797 16.0952 12.3216 15.7084 12.7084C15.3216 13.0952 14.797 13.3125 14.25 13.3125H5.97075C5.68575 13.3125 5.4165 13.4422 5.23875 13.665L3.49125 15.8497C2.89275 16.5967 1.6875 16.1745 1.6875 15.2175V3.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.cf5d24eed21c7efcb2cb99dd8df225c8.svg";
export { ForwardRef as ReactComponent };